import { logger, METRIC_NAME, DIMENSION_NAME } from '@amzn/atoz-shiftapp-metrics';
/**
 * Uses the window.performance API to replicate the CSM "cf" log by determining
 * the delta from when the page was navigated to and when a page critical feature
 * "tag" is encountered
 */
var NavigationStartToCriticalFeature = /** @class */ (function () {
    function NavigationStartToCriticalFeature() {
    }
    NavigationStartToCriticalFeature.log = function (pageName) {
        var _a;
        if (!NavigationStartToCriticalFeature._hasLogged) {
            NavigationStartToCriticalFeature._hasLogged = true;
            if (!window.performance) {
                logger.warn('Caught error while emitting NavigationStartToCriticalFeature metric', {
                    error: new Error('Browser performance object not defined')
                });
                return;
            }
            var navigationDelta = window.performance.now();
            if (navigationDelta > 0) {
                logger.emitLatencyMetric({
                    metricName: METRIC_NAME.PAGE_NAV_START_TO_CRITICAL_FEATURE,
                    metricValue: navigationDelta,
                    dimensions: (_a = {},
                        _a[DIMENSION_NAME.PAGE_NAME] = pageName,
                        _a)
                });
            }
        }
    };
    NavigationStartToCriticalFeature._hasLogged = false;
    return NavigationStartToCriticalFeature;
}());
export { NavigationStartToCriticalFeature };
